














































































































import { Component, Watch } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import DataTable from '@/components/molecules/DataTable/DataTable.vue'
import {
  Col,
  findSortColumnItem,
  setSortOrder,
  SortColumn
} from '@/components/molecules/DataTable'
import { SortOrder } from '@/types'
import { orderBy } from 'lodash'
import IconBibliography from '@/components/molecules/IconBibliography/IconBibliography.vue'
import { SimpleCollection, SystemCode } from '@/api'
import { modalCollectionSelectStore } from '@/utils/store-accessor'
import { audioNotify } from '@/utils'

interface TableItem extends SimpleCollection {
  isSelected: boolean
}

const COLS: Col[] = [
  {
    width: 26,
    items: [
      {
        name: 'radio',
        align: 'center'
      }
    ]
  },
  {
    width: 50,
    items: [
      {
        name: 'no',
        align: 'right'
      }
    ]
  },
  {
    width: '32',
    resizable: true,
    movable: false,
    items: [
      {
        name: 'displayTitle',
        headerText: 'タイトル',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '17',
    resizable: true,
    movable: false,
    items: [
      {
        name: 'collectionStatus',
        headerText: '資料状態',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '17',
    resizable: true,
    movable: false,
    items: [
      {
        name: 'holdingBranchCode',
        headerText: '所蔵館',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '17',
    resizable: true,
    movable: false,
    items: [
      {
        name: 'handlingType',
        headerText: '取扱区分',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '17',
    resizable: true,
    movable: false,
    items: [
      {
        name: 'acceptDate',
        headerText: '受入日',
        sortable: true,
        sortOrder: ''
      }
    ]
  }
]

@Component({
  components: {
    IconBibliography,
    DataTable,
    ModalFooter
  }
})
export default class ModalCollectionSelect extends ModalComponentBaseVue {
  tableItems: TableItem[] = []

  tableBodyHeight: number = 0

  sortName: string = ''

  sortOrder: SortOrder = ''

  get isOpen(): boolean {
    return modalCollectionSelectStore.isOpen
  }

  get collectionNo(): string {
    return modalCollectionSelectStore.collectionNo
  }

  get simpleCollections(): SimpleCollection[] {
    return modalCollectionSelectStore.simpleCollections
  }

  get cols(): Col[] {
    return COLS
  }

  get sortedTableItems(): TableItem[] {
    if (this.sortName) {
      return orderBy<TableItem>(
        this.tableItems,
        (item: TableItem) => {
          const propertyValue = item[this.sortName as keyof TableItem]
          const type: string = Object.prototype.toString
            .call(propertyValue)
            .slice(8, -1)
            .toLowerCase()

          if (type === 'object') return (propertyValue as SystemCode).shortName

          return propertyValue
        },
        this.sortOrder as 'asc' | 'desc'[]
      )
    }

    return this.tableItems
  }

  get tableItemsCount(): number {
    return this.tableItems.length
  }

  @Watch('isOpen')
  initialize(): void {
    if (this.isOpen) {
      this.tableItems = this.simpleCollections.map(
        (collection: SimpleCollection, index: number) => {
          return {
            isSelected: index === 0,
            ...collection
          }
        }
      )
      window.addEventListener('resize', this.calculateTableHeight)
      this.$nextTick(this.calculateTableHeight)
      audioNotify()
    }

    this.tableBodyHeight = 0
    this.onSort({
      name: '',
      order: ''
    })
    window.removeEventListener('resize', this.calculateTableHeight)
  }

  close(): void {
    modalCollectionSelectStore.close()
  }

  calculateTableHeight() {
    this.tableBodyHeight = 0

    this.$nextTick(() => {
      this.tableBodyHeight = this.calculateTableHeightBase()
    })
  }

  onClickOk(): void {
    modalCollectionSelectStore.ok(
      this.tableItems.find(value => value.isSelected)?.id ?? 0
    )
  }

  onClickCancel(): void {
    modalCollectionSelectStore.cancel()
  }

  onClickPrint(): void {
    const element = document.getElementById('modal-collection-select')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  onSort(sortColumn: SortColumn) {
    setSortOrder(this.cols, sortColumn)

    const sortColItem = findSortColumnItem(this.cols)

    this.sortName = sortColItem?.name ?? ''
    this.sortOrder = sortColItem?.sortOrder ?? ''
  }

  onClickRow(index: number): void {
    const targetIndex: number = this.tableItems.findIndex(
      value => value.id === this.sortedTableItems[index].id
    )
    this.tableItems.forEach((value, i) => {
      value.isSelected = i === targetIndex
    })
  }
}
